import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CustomAuthLoader } from '../auth/auth-config';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export const ProtectedRouteProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomAuthLoader>
        {children}
      </CustomAuthLoader>
    </QueryClientProvider>
  );
};
